import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetAllPR_InformationSocialMediaByPR_ReportsStagesGuid =
  createAsyncThunk(
    "InformationSocialMedia/GetAllPR_InformationSocialMediaByPR_ReportsStagesGuid",
    async (model, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/InformationSocialMedia/GetAllPR_InformationSocialMediaByPR_ReportsStagesGuid",
          model
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaa");

        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

export const UpdatepR_InformationSocialMedia = createAsyncThunk(
  "InformationSocialMedia/UpdatepR_InformationSocialMedia",
  async (update, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/InformationSocialMedia/UpdatepR_InformationSocialMedia",
        {
          pR_InformationSocialMediaId: update.pR_InformationSocialMediaId,
          numberOfCurrentFollowers: update.numberOfCurrentFollowers,
          numberOfPosts: update.numberOfPosts,
          viewsNumber: update.viewsNumber,
          pR_SocialMediaNameId: update.pR_SocialMediaNameId,
          pR_ReportsStagesGuid: update.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteInformationSocialMedia = createAsyncThunk(
  "GetSpecificRowNoteInformationSocialMedia/GetSpecificRowNoteInformationSocialMedia",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      // return data.filter((item) => item.incrementNumber - 1 === 1);
        return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const InformationSocialMedia = createSlice({
  name: "InformationSocialMedia",
  initialState: {
    InformationSocialMediaInfo: [],
    loadingInformationSocialMediaInfo: false,
    errorInformationSocialMediaInfo: null,
    //----------------------- update -------------------------------------
    UpdateInformationSocialMediaInfo: [],
    loadingUpdateInformationSocialMediaInfo: false,
    errorUpdateInformationSocialMediaInfo: null,
    //----------------------- get specific row note -------------------------------------
    OneSpecificRowNoteInformationSocialMedia: {},
    loadingOneSpecificRowNoteInformationSocialMedia: false,
    errorOneSpecificRowNoteInformationSocialMedia: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        GetAllPR_InformationSocialMediaByPR_ReportsStagesGuid.pending,
        (state, action) => {
          state.loadingInformationSocialMediaInfo = true;
          state.InformationSocialMediaInfo = action.payload;
          state.errorInformationSocialMediaInfo = null;
        }
      )
      .addCase(
        GetAllPR_InformationSocialMediaByPR_ReportsStagesGuid.fulfilled,
        (state, action) => {
          state.loadingInformationSocialMediaInfo = false;
          state.InformationSocialMediaInfo = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetAllPR_InformationSocialMediaByPR_ReportsStagesGuid.rejected,
        (state, action) => {
          state.loadingInformationSocialMediaInfo = false;
          state.InformationSocialMediaInfo = action.payload;
        }
      )
      //-------------------------------------- update ---------------------------------------
      .addCase(UpdatepR_InformationSocialMedia.pending, (state, action) => {
        state.loadingUpdateInformationSocialMediaInfo = true;
        state.UpdateInformationSocialMediaInfo = action.payload;
        state.errorUpdateInformationSocialMediaInfo = null;
      })
      .addCase(UpdatepR_InformationSocialMedia.fulfilled, (state, action) => {
        state.loadingUpdateInformationSocialMediaInfo = false;
        state.UpdateInformationSocialMediaInfo = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdatepR_InformationSocialMedia.rejected, (state, action) => {
        state.loadingUpdateInformationSocialMediaInfo = false;
        state.UpdateInformationSocialMediaInfo = action.payload;
      })
      //-------------------------------------- get specific row note ---------------------------------------
      .addCase(
        GetSpecificRowNoteInformationSocialMedia.pending,
        (state, action) => {
          state.loadingOneSpecificRowNoteInformationSocialMedia = true;
          state.OneSpecificRowNoteInformationSocialMedia = action.payload;
          state.errorOneSpecificRowNoteInformationSocialMedia = null;
        }
      )
      .addCase(
        GetSpecificRowNoteInformationSocialMedia.fulfilled,
        (state, action) => {
          state.loadingOneSpecificRowNoteInformationSocialMedia = false;
          state.OneSpecificRowNoteInformationSocialMedia = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetSpecificRowNoteInformationSocialMedia.rejected,
        (state, action) => {
          state.loadingOneSpecificRowNoteInformationSocialMedia = false;
          state.errorOneSpecificRowNoteInformationSocialMedia = action.payload;
        }
      );
  },
});

export default InformationSocialMedia.reducer;
